<ul class="inspiration-items">
  <li *ngFor="let leg of legs" [class.active]="current.storage.legsId === leg.id">
    <figure (click)="selectLegs(leg.id)">
      <span class="media">
        <img *ngIf="leg.img !== ''" [src]="'assets/img/' + leg.img" [alt]="leg.label" />
        <span class="title-overlay">
   {{ leg.label | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
</ul>
